import { FeatureIslandContainer } from "@/components/features/_layouts";
import type * as QueryRepository from "@/components/features/settings/payment-deposit-account/repository/query";

import { SettingsPaymentDepositAccountHeader, SettingsPaymentDepositAccountMain } from "./components";
import { useUpdatePaymentDepositAccount } from "./hooks";
import * as UseCase from "../model/use-case";

type Props = {
	serverModel: QueryRepository.ServerModel;
};

export const SettingsPaymentDepositAccountPresenter = ({ serverModel }: Props) => {
	const { viewModel, onSetViewModel, onResetViewModel } = UseCase.useInitialized({ serverModel });

	const { onUpdatePaymentDepositAccount } = useUpdatePaymentDepositAccount({ viewModel, onResetViewModel });

	return (
		<FeatureIslandContainer>
			<SettingsPaymentDepositAccountHeader
				isValid={!viewModel.hasError}
				isDirty={viewModel.isDirty}
				onUpdate={onUpdatePaymentDepositAccount}
			/>
			<SettingsPaymentDepositAccountMain viewModel={viewModel} onSetViewModel={onSetViewModel} />
		</FeatureIslandContainer>
	);
};
